export const isCanvasBlank = (canvas) => {
  if (!canvas) return true;
  const ctx = canvas.getContext("2d");
  const pixelBuffer = new Uint32Array(
    ctx.getImageData(0, 0, canvas.width, canvas.height).data.buffer
  );
  return !pixelBuffer.some((color) => color !== 0);
};

export const redrawStoredStrokes = (canvas, strokes) => {
  if (!canvas) return;

  const ctx = canvas.getContext("2d");

  strokes.forEach((stroke) => {
    if (!stroke || !stroke.points || stroke.points.length < 2) return;

    ctx.beginPath();
    ctx.moveTo(stroke.points[0].x, stroke.points[0].y);

    for (let i = 1; i < stroke.points.length; i++) {
      ctx.lineTo(stroke.points[i].x, stroke.points[i].y);
    }

    if (stroke.type === "erase") {
      ctx.save();
      ctx.lineWidth = 50; // increased eraser radius for re-draw, NEEDS TO MATCH THE LINEWIDTH IN USECANVAS ERASER
      ctx.globalCompositeOperation = "destination-out";
      ctx.stroke();
      ctx.restore();
    } else {
      ctx.stroke();
    }
  });
};
